export default "__VITE_ASSET__BunZfZmz__"